import { FloatingFormItem, InputDecimal } from '@/components/_common';
import {
  InvoiceExigibility,
  InvoiceTaxType,
} from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Input, Row, Select } from 'antd';

const NoteItensIss = () => {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  const taxTypeOptions = [
    {
      value: InvoiceTaxType.EXEMPT_ISS,
      label: 'Isento de ISS',
    },
    {
      value: InvoiceTaxType.IMMUNE,
      label: 'Imune',
    },
    {
      value: InvoiceTaxType.NON_INCIDENCE_IN_CITY,
      label: 'Não incidência no município',
    },
    {
      value: InvoiceTaxType.NON_TAXABLE,
      label: 'Não tributável',
    },
    {
      value: InvoiceTaxType.WITHHELD,
      label: 'Retido',
    },
    {
      value: InvoiceTaxType.TAXABLE_WITHIN_CITY,
      label: 'Tributável dentro do município',
    },
    {
      value: InvoiceTaxType.TAXABLE_OUTSIDE_CITY,
      label: 'Tributável fora do município',
    },
    {
      value: InvoiceTaxType.TAXABLE_WITHIN_CITY_BY_TAKER,
      label: 'Tributável dentro do município pelo comprador',
    },
  ];

  const exigibilityOptions = [
    {
      value: InvoiceExigibility.EXIGIBLE,
      label: 'Exigível',
    },
    {
      value: InvoiceExigibility.NON_INCIDENCE,
      label: 'Não incidência',
    },
    {
      value: InvoiceExigibility.EXEMPTION,
      label: 'Isenção',
    },
    {
      value: InvoiceExigibility.EXPORT,
      label: 'Exportação',
    },
    {
      value: InvoiceExigibility.IMMUNITY,
      label: 'Imunidade',
    },
    {
      value: InvoiceExigibility.JUDICIAL_SUSPENSION,
      label: 'Suspenso por ação judicial',
    },
    {
      value: InvoiceExigibility.ADMINISTRATIVE_SUSPENSION,
      label: 'Suspenso por ação administrativa',
    },
  ];

  return (
    <Row gutter={[16, 16]} style={{ width: '100%' }}>
      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem
          label="Tipo de tributação"
          name={['itemTaxes', 'taxType']}
        >
          <Select options={taxTypeOptions} />
        </FloatingFormItem>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem
          label="Exigibilidade"
          name={['itemTaxes', 'exigibility']}
        >
          <Select options={exigibilityOptions} />
        </FloatingFormItem>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem label="Retido" name={['itemTaxes', 'withheld']}>
          <Select
            options={[
              {
                value: 'true',
                label: 'Sim',
              },
              {
                value: 'false',
                label: 'Não',
              },
            ]}
          />
        </FloatingFormItem>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem
          label="Aliquota"
          name={['itemTaxes', 'rate']}
          rules={[defaultEmptyFieldError]}
        >
          <InputDecimal fractions={4} max={100} />
        </FloatingFormItem>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem label="Valor" name={['itemTaxes', 'value']}>
          <InputDecimal />
        </FloatingFormItem>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem
          label="Valor retido"
          name={['itemTaxes', 'withheldValue']}
        >
          <InputDecimal />
        </FloatingFormItem>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem
          label="Processo suspensão"
          name={['itemTaxes', 'suspensionProcess']}
        >
          <Input />
        </FloatingFormItem>
      </Col>
    </Row>
  );
};

export default NoteItensIss;
